import React, { useState } from 'react'
import Sidebar from './Sidebar'
import Graph from './Graph'
import data from '../data'
import '../styles.css'

// todos los nodos y aquellas aristas que conecten este grupo de nodos
// selection es una lista de ids
const filterElements = (allElements, selection) => {
  const nodes = allElements.nodes.filter(({ data: { id }}) => selection.selectedNodes.includes(id))
  const edges = allElements.edges.filter(({ data: { source, target } }) => 
    selection.selectedNodes.includes(source) && selection.selectedNodes.includes(target))

  return ({ nodes, edges })
}

const App = () => {
  const [isOpen, setIsOpen] = useState(false)
  const [mostrarOrg, setMostrarOrg] = useState(true)
  const [mostrarSoloGrupo, setMostrarSoloGrupo] = useState(false);
  
  const [selection, setSelection] = useState(null)
  const elements = mostrarSoloGrupo ? filterElements(data.elements, selection) : data.elements

  const toggleSidebar = () => {
    setIsOpen(!isOpen)
  }

  const toggleMostrarSoloGrupo = () => {
    setMostrarSoloGrupo(!mostrarSoloGrupo);
  };

  const toggleMostrarOrg = () => {
    setMostrarOrg(!mostrarOrg)
  };


  return (
    <div className='app'>
      <div className='content'>
        <div className={`sidebar-content ${isOpen ? "open" : ""}`}>
          <button className="close-sidebar-button" onClick={toggleSidebar}></button>
          <Sidebar data={data} selection={selection} setSelection={setSelection} 
          mostrarSoloGrupo={mostrarSoloGrupo} toggleMostrarSoloGrupo={toggleMostrarSoloGrupo} 
          mostrarOrg={mostrarOrg} toggleMostrarOrg={toggleMostrarOrg} />
        </div>
        <div className={`main-content ${isOpen ? "shifted" : ""}`}>
          <div className='header'>
            <button className='open-sidebar-button' onClick={toggleSidebar}>☰</button>
          </div>
          <Graph elements={elements} selection={selection} setSelection={setSelection} mostrarOrg={mostrarOrg} />
        </div>
         
      </div>
    </div>
  )
}

export default App
